import React, { useState } from 'react';
import { FaTruck, FaSearch } from 'react-icons/fa';

const TrackOrder = () => {
  const [orderId, setOrderId] = useState('');
  const [email, setEmail] = useState('');
  const [tracked, setTracked] = useState(false);

  const handleTrack = (e) => {
    e.preventDefault();
    if (orderId && email) setTracked(true);
  };

  return (
    <div className="py-16 bg-gradient-to-b from-orange-50 to-white">
      <div className="max-w-md mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">Track <span className="text-orange-500">Order</span></h1>
          <div className="w-20 h-1 bg-orange-500 mx-auto"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8">
          <FaTruck className="text-5xl text-orange-500 mx-auto mb-6" />
          
          {!tracked ? (
            <form onSubmit={handleTrack} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Order ID</label>
                <input
                  type="text"
                  value={orderId}
                  onChange={(e) => setOrderId(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  placeholder="e.g., BRF123456"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  placeholder="you@example.com"
                  required
                />
              </div>
              <button
                type="submit"
                className="w-full bg-orange-500 text-white py-3 rounded-lg font-semibold hover:bg-orange-600 transition-colors flex items-center justify-center gap-2"
              >
                <FaSearch />
                Track Order
              </button>
            </form>
          ) : (
            <div className="text-center">
              <div className="mb-4">
                <div className="flex items-center justify-between mb-2">
                  <span className="text-sm text-gray-500">Order #{orderId}</span>
                  <span className="text-green-600 font-semibold">In Transit</span>
                </div>
                <div className="h-2 bg-gray-200 rounded-full">
                  <div className="h-2 bg-orange-500 rounded-full w-2/3"></div>
                </div>
              </div>
              <p className="text-gray-600">Estimated delivery: 3-5 business days</p>
              <button
                onClick={() => setTracked(false)}
                className="mt-4 text-orange-500 hover:underline"
              >
                Track another order
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackOrder;